(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/game-card/countdown.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/game-card/countdown.js');

'use strict';

const {
  useContext,
  useEffect,
  useState
} = React;
const {
  useSelector,
  useDispatch
} = ReactRedux;
const {
  clientNow
} = svs.numbergames.draws.drawsApi;
const {
  ContainerContext
} = svs.numbergames.fractiongames.contexts;
const {
  actions
} = svs.numbergames.fractiongames.redux.slices.containers;
let countdown;
const subscribers = {};
function subscribeToCountdown(_ref) {
  let {
    id,
    cb
  } = _ref;
  subscribers[id] = cb;
  countdown !== null && countdown !== void 0 ? countdown : countdown = setInterval(() => Object.values(subscribers).forEach(cb => cb()), 1000);
  return () => {
    delete subscribers[id];
    if (!Object.keys(subscribers).length) {
      clearInterval(countdown);
      countdown = null;
    }
  };
}
function calcDisplayTimeLeft(buyinCloseTime) {
  if (!buyinCloseTime) return {
    minutesLeft: 0,
    secondsLeft: 0
  };
  const MS_IN_MINUTE = 60 * 1000;
  const millisecondsDiff = dateFns.differenceInMilliseconds(new Date(buyinCloseTime), clientNow());
  return {
    minutesLeft: millisecondsDiff > MS_IN_MINUTE ? Math.ceil(millisecondsDiff / MS_IN_MINUTE) : 0,
    secondsLeft: millisecondsDiff <= MS_IN_MINUTE && millisecondsDiff > 0 ? Math.ceil(millisecondsDiff / 1000) : 0
  };
}
function formatCountdownText(count, text) {
  count = count > 9 ? count : " ".concat(count); 
  text = count > 1 ? "".concat(text, "er") : "".concat(text, "  "); 
  return "".concat(count, " ").concat(text);
}
const Countdown = () => {
  const dispatch = useDispatch();
  const {
    selectors
  } = useContext(ContainerContext);
  const containerId = useSelector(selectors.selectContainerId);
  const buyinCloseTime = useSelector(selectors.selectBuyinCloseTime);
  const [secondsLeft, setSecondsLeft] = useState(calcDisplayTimeLeft(buyinCloseTime).secondsLeft);
  const [minutesLeft, setMinutesLeft] = useState(calcDisplayTimeLeft(buyinCloseTime).minutesLeft);
  useEffect(() => {
    const unsubscribe = subscribeToCountdown({
      id: containerId,
      cb: () => {
        const {
          minutesLeft,
          secondsLeft
        } = calcDisplayTimeLeft(buyinCloseTime);
        setMinutesLeft(minutesLeft);
        setSecondsLeft(secondsLeft);
        if (!minutesLeft && !secondsLeft) {
          dispatch(actions.gameBuyinClosed(containerId));
        }
      }
    });
    return () => unsubscribe();
  }, [buyinCloseTime, containerId, dispatch]);
  return React.createElement("span", {
    className: "f-numeric"
  }, "K\xF6pstopp om: ", minutesLeft ? formatCountdownText(minutesLeft, 'minut') : formatCountdownText(secondsLeft, 'sekund'));
};
svs.numbergames.fractiongames.components.gamecard.Countdown = Countdown;

 })(window);